import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_AIR_DETAILS.id,
    mainReportId: ReportDefinitions.ITEMS_WITH_HANDOVER_DATA_AIR_SUMMARY.id,
    requestParams: {
      operatorFrom: rowInfo.row['originOperator'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator'),
        new NavigationColumn(new NonZeroNumberColumn('Total items', 'totalItems'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Count',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Items with handover data', 'count.itemsWithHandoverData'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('MRD data', 'count.mrdData'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('R21 or RESCON', 'count.r21orRescon'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No CARDIT', 'count.noCardit'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No PRECON', 'count.noPrecon'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('No delivery event', 'count.noDeliveryEvent'), getDetailsTabNavOptions),
        new NavigationColumn(new NonZeroNumberColumn('MRD denest fail', 'count.mrdDenestFail'), getDetailsTabNavOptions),
      ],
    },
    {
      Header: 'Percentage',
      columns: [
        new NonZeroPercentageColumn('Items with handover data', 'percentage.itemsWithHandoverData'),
        new NonZeroPercentageColumn('MRD data', 'percentage.mrdData'),
        new NonZeroPercentageColumn('R21 or RESCON', 'percentage.r21orRescon'),
        new NonZeroPercentageColumn('No CARDIT', 'percentage.noCardit'),
        new NonZeroPercentageColumn('No PRECON', 'percentage.noPrecon'),
        new NonZeroPercentageColumn('No delivery event', 'percentage.noDeliveryEvent'),
        new NonZeroPercentageColumn('MRD denest fail', 'percentage.mrdDenestFail'),
      ],
    },
  ];
};
